@if (recurringTest) {
  <app-test-recurring-form
    [test]="recurringTest"
    action="{{ 'edit' | translate }}"
    [isEdit]="true"
    (close)="closeForm()">
  </app-test-recurring-form>
}
